define('viewmodels/VisualAnalytics/RiskDashBoard',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/GeneralSettings'], function (ko, router, appsecurity, navigation, app, logger, system, ObjGeneralSettings) {
    var title = 'System Overview';
    var VRViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        detached: detached,
        //Filter feature
        openSideNav: openSideNav,
        closeSideNav: closeSideNav,
        OrgLvlDrpDwnList: ko.observableArray(),
        OrgLvlValueList: ko.observableArray(),
        SubCheckboxSelected: SubCheckboxSelected,
        BusinessUnitListForFilters: ko.observableArray([]),
        BusinessUnitListForFiltersDUP: ko.observableArray([]),
        SelectedCheckedList: ko.observableArray([]),
        ClearOrgFilterSelection: ClearOrgFilterSelection,
        BusinessUnitListDUP: ko.observableArray([]),
        ApplyBuFitlers: ApplyBuFitlers,
        ClearAllBuFitlers: ClearAllBuFitlers,
        BUFiltersAppliedRiskDashboard: ko.observable(false),
        FinalOrgFilterList: ko.observableArray([]),
        DistinctFileredBUs: ko.observableArray([]),
        BusinessUnitList: ko.observableArray([]),
        NumberOfBUsSelected: ko.observable(0),
        ObjGeneralSettings: ObjGeneralSettings,
        SelectedAssessmentType: ko.observable(""),
        AssessmentTypeList: ko.observableArray([]),
        //Filter feature till here
        PercentageFlag: ko.observable(false),
        //Trend Analysis
        TrendList: ko.observableArray(),
        ProfileList: ko.observableArray(),
        ProfileOne: ko.observable("Profile One"),
        ProfileTwo: ko.observable("Profile Two"),
        SelectedProfileOne: ko.observable(""),
        SelectedProfileTwo: ko.observable(""),
        SearchProfiles: SearchProfiles,
        ProfileListCountFlag: ko.observable(false),
        TrendListFlag: ko.observable(false),
        //Trend Analysis chart till here

        //Heatmap Matrix
        BusinessUnitListForHeatMap: ko.observableArray([]),
        RiskDashboardHeatMapList: ko.observableArray([]),
        HeatMapRectangleList: ko.observableArray([]),
        openLegendSideNav: openLegendSideNav,
        closeLegendSideNav: closeLegendSideNav,
        HeatmapLegendList: ko.observableArray(),
        //Heat map matrix till here

        //Legends
        InherentRiskRatingLegendList: ko.observableArray([]),
        ControlRatingLegendList: ko.observableArray([]),
        InherentDistributionLegendList: ko.observableArray([]),
        ControlDistributionLegendList: ko.observableArray([]),
        //Legends till here

        BUTitle: ko.observable('Business Unit'),
        IsSideNavOpen: ko.observable(0),
        SelectedCheckedBUList: ko.observableArray([]),
        OrgNameSelected: ko.observable(""),
        SubOrgNameSelected: ko.observable(""),

        LocaleCheckFlag: ko.observable(false),
    }



    return VRViewModel;

    function activate() {
        try {

            if (VRViewModel.ObjGeneralSettings === undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((VRViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && VRViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                VRViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (VRViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() == null || VRViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || VRViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || VRViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        VRViewModel.LocaleCheckFlag(false);
                    else
                        VRViewModel.LocaleCheckFlag(true);
                });
            } else
                VRViewModel.LocaleCheckFlag(true);

            VRViewModel.BUTitle((VRViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() == null || VRViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || VRViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || VRViewModel.ObjGeneralSettings.LocalizedIndexList() == null || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in SystemOverview.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            closeSideNav();
            VRViewModel.BUFiltersAppliedRiskDashboard(false);
            GetAllAssessmentTypes();

            //Trend analysis dropdowns
            VRViewModel.ObjGeneralSettings.ResetForm();
            VRViewModel.ProfileList(VRViewModel.ObjGeneralSettings.ProfileList());

            if (VRViewModel.ProfileList().length > 1) {
                VRViewModel.ProfileListCountFlag(true);
            } else {
                VRViewModel.ProfileListCountFlag(false);
            }

            if (VRViewModel.ObjGeneralSettings === undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((VRViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && VRViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                VRViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (VRViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || VRViewModel.ObjGeneralSettings.LocalizedTextList() == null || VRViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || VRViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || VRViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        VRViewModel.LocaleCheckFlag(false);
                    else
                        VRViewModel.LocaleCheckFlag(true);
                });
            }


            //document.getElementById('RiskDashboardSubContainer').innerHTML = "";
            document.getElementById('inherentRiskDistributionChart').innerHTML = "";
            document.getElementById('inherentRiskRatingChart').innerHTML = "";
            document.getElementById('scatterPlotChart').innerHTML = "";
            document.getElementById('controlRiskDistributionChart').innerHTML = "";
            document.getElementById('controlRiskRatingChart').innerHTML = "";

            GetAllOrganizationalLevels();
            $('#ScattorplotSpin').show();
            $('#RiskDashboardSubContainer').css({ "display": "none" });

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in SystemOverview.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in SystemOverview.js';
            logger.logMessage(msg);
        }
    };
    //Apply filter event
    function ApplyBuFitlers(data, event) {
        try {
            $('#ScattorplotSpin').show();
            $('#RiskDashboardSubContainer').css({ "display": "none" });
            VRViewModel.BusinessUnitList(VRViewModel.BusinessUnitListForFilters());
            VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length)

            //Logic to rebind the below page
            //if ((VRViewModel.SelectedCheckedList()[0] != undefined && VRViewModel.SelectedCheckedList()[0].SubLevelId != "")
            //    subLevelId

            if ((VRViewModel.SelectedCheckedList()[0] != undefined && VRViewModel.SelectedCheckedList()[0].SubLevelId != "") ||
                (VRViewModel.SelectedCheckedBUList()[0] != undefined && VRViewModel.SelectedCheckedBUList()[0].SubLevelId != "")) {

                if (document.getElementById('inherentRiskDistributionChart') != null)
                    document.getElementById('inherentRiskDistributionChart').innerHTML = "";

                if (document.getElementById('inherentRiskRatingChart') != null)
                    document.getElementById('inherentRiskRatingChart').innerHTML = "";

                if (document.getElementById('scatterPlotChart') != null)
                    document.getElementById('scatterPlotChart').innerHTML = "";

                if (document.getElementById('controlRiskDistributionChart') != null)
                    document.getElementById('controlRiskDistributionChart').innerHTML = "";

                if (document.getElementById('controlRiskRatingChart') != null)
                    document.getElementById('controlRiskRatingChart').innerHTML = "";

                SetFilterSelection();

                VRViewModel.OrgNameSelected(VRViewModel.SelectedCheckedList()[0].OrgLevelName);
                VRViewModel.SubOrgNameSelected(VRViewModel.SelectedCheckedList()[0].SubLevelName);



                //Distribution charts
                InherentRiskDistributionChart(VRViewModel.SelectedCheckedList()[0].SubLevelId, VRViewModel.SelectedAssessmentType());
                ControlRiskDistributionChart(VRViewModel.SelectedCheckedList()[0].SubLevelId, VRViewModel.SelectedAssessmentType());

                //Heatmap chart
                GetHeatMap(VRViewModel.SelectedCheckedList()[0].SubLevelId, VRViewModel.SelectedAssessmentType());

                //bullet charts
                InherentRiskRatingChart(VRViewModel.SelectedCheckedList()[0].SubLevelId, VRViewModel.SelectedAssessmentType());
                ControlRiskRatingChart(VRViewModel.SelectedCheckedList()[0].SubLevelId, VRViewModel.SelectedAssessmentType());

                $('#ApplyFilterMessage').css({ 'display': 'none' });
                $('#SelectOrgMessage').css({ 'display': 'none' });
                $('#RiskDashboardSubContainer').css({ "display": "block" });
                closeSideNav();
                VRViewModel.BUFiltersAppliedRiskDashboard(true);
                VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length);

                GetSpeedometerData();

                $('.badge').css({ 'display': 'inline-block' });
                $("#f-filter").css("display", "");
                //Trend Analysis on first load
                SearchProfilesOnSearch(0, 0, 0, 0);
            } else {
                //$('#RiskDashboardSubContainer').css({ "display": "inline-flex" });
                $('#SelectOrgMessage').css({ 'display': 'block' });
                //$('#ApplyFilterMessage').css({ 'display': 'block' });
            }
        }
        catch (e) {
            $('#ScattorplotSpin').hide();
            var msg = 'Exception: ' + e + ' | Source: ApplyBuFitlers() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function ClearBUFilterSelection(data, event) {
        try {

            var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
            document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

            $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
            if (VRViewModel.SelectedCheckedBUList().length > 0) {
                VRViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
            }

            //Logic to re-set the BU list
            VRViewModel.BusinessUnitListForFilters([]);
            if (VRViewModel.SelectedCheckedBUList().length > 0) {
                var mappedBuList = $.map(VRViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                    for (var m = 0; m < VRViewModel.SelectedCheckedBUList().length; m++) {
                        if (result.BusinessUnitId() == VRViewModel.SelectedCheckedBUList()[m].SubLevelId)
                            return new BusinessUnitModelDUP(result);
                    }
                });
                VRViewModel.BusinessUnitListForFilters(mappedBuList);

            }
            else {
                VRViewModel.BusinessUnitListForFilters([]);
                var mappedBuList = $.map(VRViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                    return new BusinessUnitModelDUP(result);
                });
                VRViewModel.BusinessUnitListForFilters(mappedBuList);

                $('#OrgFilterError').hide();
                $('#OrgSingleFilterError').hide();

            }
            //Set count of BU's selected
            if (VRViewModel.BusinessUnitListForFilters().length > 0) {
                VRViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return VRViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                VRViewModel.BusinessUnitListForFilters(VRViewModel.DistinctFileredBUs());
            }

            VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in ResidualRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }

    function RenderSpeedometer(DivName, datalenstart, Names, Percentage, tickslegendstart, bindlegend, TotalLength, color) {
        try {
            div = d3.select("#" + DivName).append("div").attr("class", "toolTipPiechart");
            div.style("display", "none");


            var gauge = function (container, configuration) {
                var that = {};
                var config = {
                    size: 200,
                    clipWidth: 200,
                    clipHeight: 80,
                    ringInset: 20,
                    ringWidth: 30,
                    TotalLength: TotalLength,
                    Low: 10,
                    Medium: 20,
                    High: 70,
                    datalen: datalenstart,
                    tickslegend: tickslegendstart,
                    pointerWidth: 10,
                    pointerTailLength: 5,
                    pointerHeadLengthPercent: 0.9,
                    legendangle: (((Percentage / 100) * 180) - 90),
                    minValue: 0,
                    maxValue: 10,

                    minAngle: -90,
                    maxAngle: 90,

                    transitionMs: 750,

                    majorTicks: datalenstart.length,
                    labelFormat: d3.format(',g'),
                    labelInset: 10,
                    arcColorFn: color
                    //arcColorFn:d3.scale.linear()
                    //    .range([)
                    //    .interpolate(d3.interpolateHcl)
                    // arcColorFn: d3.scale.linear().range(['green','Yellow','red']).interpolateHsl(d3.interpolateHsl)
                };
                var range = undefined;
                var r = undefined;
                var pointerHeadLength = undefined;
                var value = 0;

                var svg = undefined;
                var arc = undefined;
                var scale = undefined;
                var ticks = undefined;
                var tickData = undefined;
                var pointer = undefined;


                var donut = d3.layout.pie();

                function deg2rad(deg) {
                    return deg * Math.PI / 180;
                }

                function newAngle(d) {
                    var ratio = scale(d);
                    var newAngle = config.minAngle + (ratio * range);
                    return newAngle;
                }
                var startangle = -90;
                //var TextAngle=[-90,-72,-36,-90]
                var TextAngle = [-90];
                function configure(configuration) {
                    var prop = undefined;
                    for (prop in configuration) {
                        config[prop] = configuration[prop];
                    }

                    range = config.maxAngle - config.minAngle;
                    r = config.size / 2;
                    pointerHeadLength = (Math.round(r * config.pointerHeadLengthPercent) - 20) - 10;

                    // a linear scale that maps domain values to a percent from 0..1
                    scale = d3.scale.linear()
                        .range([0, 1])
                        .domain([config.minValue, config.maxValue]);

                    ticks = config.datalen;
                    //tickData = [10/100,20/100,70/100]
                    tickData = d3.range(config.datalen.length).map(function (d, i) { return config.datalen[i] / config.TotalLength });
                    arc = d3.svg.arc()
                        .innerRadius(r - config.ringWidth - config.ringInset + 45)
                        .outerRadius(r - config.ringInset + 15)
                        .startAngle(function (d, i) {
                            var ratio = d * i;

                            return deg2rad(startangle);
                        })
                        .endAngle(function (d, i) {
                            var ratio = d;
                            startangle = startangle + (ratio * range)
                            TextAngle.push(startangle);
                            return deg2rad(startangle);

                        });
                }
                that.configure = configure;

                function centerTranslation() {
                    return 'translate(' + (r + 10) + ',' + (r + 5) + ')';
                }

                function isRendered() {
                    return (svg !== undefined);
                }
                that.isRendered = isRendered;

                function render(newValue) {
                    svg = d3.select(container)
                        .append('svg:svg')
                        .attr('class', 'gauge')
                        .attr('width', config.clipWidth)
                        .attr('height', config.clipHeight);

                    var centerTx = centerTranslation();

                    var arcs = svg.append('g')
                        .attr('class', 'arc')
                        .attr('transform', centerTx);

                    arcs.selectAll('path')
                        .data(tickData)

                        .enter().append('path')
                        .attr('fill', function (d, i) {
                            return config.arcColorFn[i];
                        })
                        .style('stroke', '#d6d3d3')
                        .style('stroke-width', '3')

                        .attr('d', arc)
                        .on("mousemove", function (d, i, j) {
                            var x = parseInt(d3.event.pageX);
                            var y = parseInt(d3.event.pageY);
                            div.style("left", x - 940 + "px");
                            div.style("top", y - 100 + "px");
                            div.html((Names[i]));
                            div.style("display", "block");

                        })
                        .on("mouseout", function (d, i, j) {
                            div.style("display", "none");
                        });

                    if (parseInt(bindlegend) == 1) {

                        var lg = svg.append('g')
                            .attr('class', 'label')
                            .attr('transform', centerTx);
                        lg.selectAll('text')
                            .data(config.tickslegend)
                            .enter().append('text')
                            .attr('transform', function (d, i) {
                                //var ratio = scale(d);
                                //  var newAngle = config.minAngle + (ratio * range);
                                //code to change the labels
                                return 'rotate(' + config.legendangle + ') translate(12,' + (config.labelInset - r - 9 + 25) + ')';

                            })
                            .text(config.labelFormat);
                    }
                    var lineData = [[1, -10],
                    [0, -pointerHeadLength - 30],
                    [-(config.pointerWidth / 4) - 1, 0],];
                    // [0, config.pointerTailLength-10],
                    //[config.pointerWidth-2 / 1.75, 0]];
                    var pointerLine = d3.svg.line().interpolate('monotone');
                    var pg = svg.append('g').data([lineData])
                        .attr('class', 'pointer')
                        // .attr('transform', centerTx);
                        .attr('transform', centerTx);

                    pointer = pg.append('path')
                        .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/)
                        .attr('transform', 'rotate(' + config.minAngle + ')');

                    update(newValue === undefined ? 0 : newValue);
                }
                that.render = render;

                function update(newValue, newConfiguration) {
                    if (newConfiguration !== undefined) {
                        configure(newConfiguration);
                    }
                    var ratio = scale(newValue);
                    var newAngle = config.minAngle + (ratio * range);
                    pointer.transition()
                        .duration(config.transitionMs)
                        .ease('elastic')
                        .attr('transform', 'rotate(' + newAngle + ')');
                }
                that.update = update;

                configure(configuration);

                return that;
            };
            var powerGauge = gauge('#' + DivName, {
                size: 150,
                clipWidth: 200,
                clipHeight: 80,
                ringWidth: 60,
                maxValue: 100,
                transitionMs: 4000,
            });
            powerGauge.render();
            function updateReadings() {
                // just pump in random data here...
                powerGauge.update(Percentage);
            }
            updateReadings();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }



    function InherentRiskRatingChart(subOrgLevelId, AssessementTypeId) {
        try {
            $.ajax({
                url: "/api/Visualization/GetRDInherentRiskRatings",
                data: { SubOrgLevelId: subOrgLevelId, AssessementTypeId: AssessementTypeId },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in InherentRiskRatingChart() method in RiskDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    $('#inherentRiskRatingChartError').hide();
                    DrawInherentRiskRatingChart(jsonResult);
                    if (jsonResult[0].InherentRiskLegendList != null && jsonResult[0].InherentRiskLegendList.length > 0) {
                        var MappedLegendList = $.map(jsonResult[0].InherentRiskLegendList, function (result) {
                            return new InherentRiskRatingLegendModel(result);
                        })
                        VRViewModel.InherentRiskRatingLegendList(MappedLegendList);
                    }
                }
                else {
                    $('#inherentRiskRatingChartError').show();
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(AMLRaViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in InherentRiskRatingChart() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please login again to complete the operation."
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InherentRiskRatingChart() method in RiskDashboard.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in InherentRiskRatingChart() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
    }

    function InherentRiskRatingLegendModel(item) {
        try {
            var self = this;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskScore = item.RiskScore;
            self.ColorCode = item.ColorCode;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskRatingLegendModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function DrawInherentRiskRatingChart(bulletsjson) {

        //var bulletsjson = [
        //    { "title": "Customers", "measures": [1, 2, 3, 4], "CalculatedRiskScore": [1.3], "toolTipData": "first text", "ranges": [0] },
        //    { "title": "Products", "measures": [1, 2, 3, 4], "CalculatedRiskScore": [0.8], "toolTipData": "2 text", "ranges": [0] },
        //    { "title": "Services", "measures": [1, 2, 3, 4], "CalculatedRiskScore": [3.5], "toolTipData": "3 text", "ranges": [0] },
        //    { "title": "Transactions", "measures": [1, 2, 3, 4], "CalculatedRiskScore": [2.3], "toolTipData": "4 text", "ranges": [0] },
        //];

        var margin = { top: 5, right: 40, bottom: 20, left: 140 },
            width = 500 - margin.left - margin.right - 40,
            height = 50 - margin.top - margin.bottom;

        var chart = d3.bullet()
            .width(width)
            .height(height);

        var svg = d3.select("#inherentRiskRatingChart").selectAll("svg")
            .data(bulletsjson)
            .enter().append("svg")
            .attr("class", "bullet")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)


        var title = svg.append("g")
            .style("text-anchor", "start")
            .attr("transform", "translate(0,22)");

        title.append("title").html(function (d) { return d.RiskAreaName; })
        title.style("cursor", "pointer")

        title.append("text")
            .attr("class", "title")
            .text(function (d) { return d.RiskAreaName; })
            .call(function (t) {
                t.each(function (d) { // for each one
                    var self = d3.select(this);
                    var s = self.text().split(' ');  // get the text and split it
                    if (s[1] == undefined || s[1] == "") {
                        s[1] = "";
                    }
                    if (s[2] == undefined || s[2] == "") {
                        s[2] = "";
                    }
                    if (s[3] == undefined || s[3] == "") {
                        s[3] = "";
                    }
                    self.text(''); // clear it out
                    var text1 = s[0] + " " + s[1];
                    var text2 = s[2] + " " + s[3];

                    if (text1.length > 20) {
                        text1 = text1.substr(0, 16) + "...";
                        text2 = "";
                    }
                    if (text2 != "" && text1.length > 20) {
                        text2 = text2.substr(0, 16) + "...";
                    }
                    self.append("tspan") // insert two tspans
                        .attr("x", 0)
                        .attr("dy", 0)
                        .text(text1);

                    self.append("tspan")
                        .attr("x", 0)
                        .attr("dy", 14)
                        .text(text2);

                })
            });

        svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
            .call(chart);

        //title.append("text")
        //    .attr("class", "subtitle")
        //    .attr("dy", "1em")
        //    .text(function (d) { return d.subtitle; });

        $("#inherentRiskRatingChartPopUp").html('');
        $("#inherentRiskRatingChartPopUp").html($("#inherentRiskRatingChart").html());
    }


    function ControlRiskRatingChart(subOrgLevelId, AssessementTypeId) {
        try {
            $.ajax({
                url: "/api/Visualization/GetRDControlRatings",
                data: { SubOrgLevelId: subOrgLevelId, AssessementTypeId: AssessementTypeId },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in ControlRiskRatingChart() method in RiskDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    $('#controlRiskRatingChartError').hide();
                    DrawControlRiskRatingChart(jsonResult);
                    if (jsonResult[0].ControlRatingsLegendList != null && jsonResult[0].ControlRatingsLegendList.length > 0) {
                        var MappedLegendList = $.map(jsonResult[0].ControlRatingsLegendList, function (result) {
                            return new ControlRatingsLegendModel(result);
                        })
                        VRViewModel.ControlRatingLegendList(MappedLegendList);
                    }
                }
                else {
                    $('#controlRiskRatingChartError').show();
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(AMLRaViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in ControlRiskRatingChart() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please login again to complete the operation."
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in ControlRiskRatingChart() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in ControlRiskRatingChart() method in Reports.js';
                logger.logMessage(msg);
            }
        }
    }

    function ControlRatingsLegendModel(item) {
        try {
            var self = this;
            self.RiskLevelName = item.RiskLevelName;
            self.Range = item.Range;
            self.ColorCode = item.ColorCode;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskRatingLegendModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function DrawControlRiskRatingChart(bulletsjson) {
        //var bulletsjson = [
        //    { "title": "Customer Due Diligence", "measures": [10 / 10, 8.9 / 10, 7.4 / 10], "CalculatedRiskScore": [2.6 / 10], "toolTipData": '26', "ranges": [0.20, 0.55] },
        //    { "title": "Policies & Procedures", "measures": [10 / 10, 8 / 10, 5 / 10, 3 / 10], "CalculatedRiskScore": [7 / 10], "toolTipData": "15", "ranges": [0.4, 0.8] },
        //    { "title": "KYC", "measures": [10 / 10, 8 / 10, 5 / 10, 3 / 10], "CalculatedRiskScore": [3.2 / 10], "toolTipData": "32", "ranges": [0.32, 0.6] },
        //    { "title": "Risk Based Approach", "measures": [10 / 10, 8 / 10, 5 / 10, 3 / 10], "CalculatedRiskScore": [4.6 / 10], "toolTipData": "46", "ranges": [0.4, 0.7] },
        //    { "title": "Training", "measures": [10 / 10, 8 / 10, 5 / 10, 3 / 10], "CalculatedRiskScore": [6.0 / 10], "toolTipData": "80", "ranges": [0.6, 1] }
        //];
        var margin = { top: 5, right: 40, bottom: 20, left: 140 },
            width = 500 - margin.left - margin.right - 40,
            height = 50 - margin.top - margin.bottom;

        var chart = d3.bullet()
            .width(width)
            .height(height);

        var svg = d3.select("#controlRiskRatingChart").selectAll("svg")
            .data(bulletsjson)
            .enter().append("svg")
            .attr("class", "bullet")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)


        var title = svg.append("g")
            .style("text-anchor", "start")
            .attr("transform", "translate(0,22)");

        title.append("title").html(function (d) { return d.ControlAreaName; })
        title.style("cursor", "pointer")

        title.append("text")
            .attr("class", "title")
            .text(function (d) { return d.ControlAreaName; })
            .call(function (t) {
                t.each(function (d) { // for each one
                    var self = d3.select(this);
                    var s = self.text().split(' ');  // get the text and split it
                    if (s[1] == undefined || s[1] == "") {
                        s[1] = "";
                    }
                    if (s[2] == undefined || s[2] == "") {
                        s[2] = "";
                    }
                    if (s[3] == undefined || s[3] == "") {
                        s[3] = "";
                    }
                    self.text(''); // clear it out
                    var text1 = s[0] + " " + s[1];
                    var text2 = s[2] + " " + s[3];

                    if (text1.length > 20) {
                        text1 = text1.substr(0, 16) + "...";
                        text2 = "";
                    }
                    if (text2 != "" && text1.length > 20) {
                        text2 = text2.substr(0, 16) + "...";
                    }
                    self.append("tspan") // insert two tspans
                        .attr("x", 0)
                        .attr("dy", 0)
                        .text(text1);

                    self.append("tspan")
                        .attr("x", 0)
                        .attr("dy", 14)
                        .text(text2);

                })
            });

        svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
            .call(chart);

        $("#controlRiskRatingChartPopUp").html('');
        $("#controlRiskRatingChartPopUp").html($("#controlRiskRatingChart").html());
    }

    //-----------------------------------------------------------------------------Filter logic----------------------------------------------------------------------------------//
    function openSideNav() {
        try {
            if ($('#BusinessUnitFilterBtn').hasClass("openFilter")) {
                closeSideNav();
            } else {
                //$('#ApplyFilterMessage').css({ 'display': 'none' });

                $('#BusinessUnitFilterBtn').addClass("openFilter");
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                $('#OrgSingleFilterError').hide();
                $('#OrganizationalLevel').show();
                $('#BuselectFilter').show();
                $('#FilterButton').show();

                if (VRViewModel.BUFiltersAppliedRiskDashboard() == false) {
                    $('#ScattorplotSpin').show();
                    //GetAllOrganizationalLevels();
                }
            }
            VRViewModel.IsSideNavOpen(1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: openSideNav() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function closeSideNav() {
        try {
            $('#SelectOrgMessage').css({ 'display': 'none' });

            $('#BusinessUnitFilterBtn').removeClass("openFilter");
            $('#OrganizationalLevel').hide();
            $('#BuselectFilter').hide();
            $('#OrgFilterError').hide();
            $('#OrgSingleFilterError').hide();
            $('#BUFilterError').hide();
           $('#ScattorplotSpin').hide();
            $('#FilterButton').hide();
            VRViewModel.IsSideNavOpen(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function GetAllOrganizationalLevels() {
        try {
            return $.ajax({
                url: "/api/Configuration/getDistinctBusinessLevelsAll",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var OrganizationalLevels = $.map(jsonResult, function (result) {
                        return new BusinessLevelsModel(result);
                    });
                    if (OrganizationalLevels.length > 0) {
                        VRViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                        //BindHTML();
                        VRViewModel.OrgLvlValueList(VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                    }
                    else {
                        //BindHTML();
                    }
                    //Get all BU list with org sub level id's
                    //if(!VRViewModel.BusinessUnitListForFilters().length > 0)
                    GetAllBusinessUnitsForFilters();

                    VRViewModel.SelectedCheckedList([]);
                    document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                }
                else
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(VRViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please login again to complete the operation."
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }
    //---------------------------------------------------------------------------------Logic For Populating the Organizational Levels Ends Here---------------------------------------------------------//
    //---------------------------------------------------------------------------------Logic For Populating the Populating the Business Units with sub levels Starts Here---------------------------------------------------------//
    function GetAllBusinessUnitsForFilters() {
        try {

            return $.ajax({
                url: "/api/AMLRiskAssessment/GetAllBusinessUnitsForFilters",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllBusinessUnitsForFilters() in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedBuList = $.map(jsonResult, function (result) {
                        return new BusinessUnitModel(result);
                    });
                    VRViewModel.BusinessUnitListForFilters(mappedBuList);
                    VRViewModel.BusinessUnitListForFiltersDUP(mappedBuList);
                    VRViewModel.BusinessUnitListDUP = ko.dependentObservable(function () {
                        var seen = [];
                        return mappedBuList.filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    BindHTML();
                    $('#OrgFilterError').hide();
                    $('#BUFilterError').hide();
                    $('#OrgSingleFilterError').hide();

                    if (VRViewModel.OrgLvlDrpDwnList() != undefined) {
                        if (VRViewModel.OrgLvlDrpDwnList().length > 0) {
                            if (VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList() != undefined) {
                                if (VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList().length > 0) {

                                    VRViewModel.SelectedCheckedList([]);

                                    $("#sublevel" + VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueId()).css({ 'display': 'inline-block' });

                                    VRViewModel.SelectedCheckedList.push({
                                        SubLevelId: VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueId(),
                                        SubLevelName: VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueName(),
                                        OrgLevelName: VRViewModel.OrgLvlDrpDwnList()[0].BlName()
                                    });
                                    VRViewModel.OrgNameSelected(VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueName());
                                    VRViewModel.SubOrgNameSelected(VRViewModel.OrgLvlDrpDwnList()[0].BlName());

                                    ApplyBuFitlers();
                                }
                            }
                        }
                    }

                }
                else
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(VRViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please login again to complete the operation."
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }
    //---------------------------------------------------------------------------------Logic For Populating the Business Units with sub levels Ends Here---------------------------------------------------------//
    //-----------------------------------------------------------------------------------Logic for binding HTML to the front end --------------------------------------------------------------------------------------//
    function BindHTMLOld() {
        try {
            //Org Level Filter Fossil style
            var OrgList = "";

            OrgList += '<div class="">' +
                '<ul class="nav nav-tabs">';

            for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                if (i == 0) {
                    OrgList += '<li class="active"><a href="#tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + VRViewModel.OrgLvlDrpDwnList()[i].BlName() + '<i class="fa fa-chevron-down" aria-hidden="true" style="margin-left: 1rem;"></i> </a></li>'
                } else {
                    OrgList += '<li class=""><a href="#tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + VRViewModel.OrgLvlDrpDwnList()[i].BlName() + '<i class="fa fa-chevron-down" aria-hidden="true" style="margin-left: 1rem;"></i> </a></li>'
                }
            }
            // OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">Business Units <i class="fa fa-chevron-down" aria-hidden="true" style="margin-left: 1rem;"></i> </a></li>'

            OrgList += '</ul>' +
                '<div class="tab-content" style="height: 12vh;overflow-y: auto;">';

            for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                if (i == 0) {
                    OrgList += '<div class="tab-pane active" id="tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                } else {
                    OrgList += '<div class="tab-pane" id="tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                }

                if (VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                    for (var j = 0; j < VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                        OrgList += '<label style="margin-top: 1rem; margin-right:3rem;cursor: pointer;">' +
                            '<input id=sublevel' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : absolute;clip : rect(0,0,0,0);pointer-events : none;">' +
                            '<i class="fa fa-check ' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i>' +
                            '<span class="cc-facet-result-text tag-text">' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span>' +
                            '</label>';
                    }

                }
                OrgList += '</div>'
            }
            //OrgList += '<div class="tab-pane" id="tab_BU">'

            VRViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                var seen = [];
                return VRViewModel.BusinessUnitListForFilters().filter(function (n) {
                    return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                });
            });

            VRViewModel.BusinessUnitListForFilters(VRViewModel.DistinctFileredBUs());

            //for (var w = 0; w < VRViewModel.BusinessUnitListForFilters().length; w++) {
            //    OrgList += '<label style="margin-top: 1rem; margin-right:2rem;cursor: pointer;">' +
            //        '<input id=sublevelBU' + VRViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : absolute;clip : rect(0,0,0,0);pointer-events : none;">' +
            //        '<i class="fa fa-check ' + VRViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
            //        '<span class="cc-facet-result-text tag-text">' + VRViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
            //        '</label>';
            //}
            //OrgList += '</div>'

            if (OrgList == "") {
                OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">';
                OrgList += //"Organizational Levels are not configured for this Year of Assessment."
                    (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelsNotConfigured') == -1) ? 'Organizational Levels are not configured for this Year of Assessment.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelsNotConfigured')].Name()
                OrgList += '</label ></div >';

            }
            document.getElementById('OrganizationalLevel').innerHTML = OrgList;

            for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                for (var l = 0; l < VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                    ko.applyBindingsToNode($('#sublevel' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: VRViewModel.SubCheckboxSelected } }, VRViewModel);
                }
            }

            //for (var k = 0; k < VRViewModel.BusinessUnitListForFilters().length; k++) {
            //    ko.applyBindingsToNode($('#sublevelBU' + VRViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: VRViewModel.SubCheckboxSelected } }, VRViewModel);
            //}
            $('#ScattorplotSpin').hide();
            VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length);
        }
        catch (e) {
            var msg = 'Exception' + e + ' || source:BindHTML function in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function BindHTML() {
        try {
            //Org Level Filter Fossil style
            var OrgList = "";

            OrgList += '<div class="filter-nav1"><ul class="nav nav-tabs"><li class="fl-lbl"><span>';
            OrgList += (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddFilters') == -1) ? 'Add Filters' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddFilters')].Name()
                //Add Filters
            OrgList += '</span> </li>';

            for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                if (i == 0) {
                    OrgList += '<li class="active"><a href="#tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + VRViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                } else {
                    OrgList += '<li class=""><a href="#tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + VRViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true" ></i> </a></li>'
                }
            }
            OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + VRViewModel.BUTitle() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'

            OrgList += '</ul><div class="tab-content filter-content">';

            for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                if (i == 0) {
                    OrgList += '<div class="tab-pane active" id="tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                } else {
                    OrgList += '<div class="tab-pane" id="tab_' + VRViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                }

                if (VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                    for (var j = 0; j < VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                        OrgList += '<label  class="ft-selection"><input id=sublevel' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;"><i class="fa fa-check ' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i><span class="cc-facet-result-text tag-text">' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span></label>';
                    }

                }
                OrgList += '</div>';
            }
            OrgList += '<div class="tab-pane" id="tab_BU">';

            VRViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                var seen = [];
                return VRViewModel.BusinessUnitListForFilters().filter(function (n) {
                    return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                });
            });

            VRViewModel.BusinessUnitListForFilters(VRViewModel.DistinctFileredBUs());

            for (var w = 0; w < VRViewModel.BusinessUnitListForFilters().length; w++) {
                OrgList += '<label class="ft-selection">' +
                    '<input id=sublevelBU' + VRViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                    '<i class="fa fa-check ' + VRViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                    '<span class="cc-facet-result-text tag-text">' + VRViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
                    '</label>';
            }
            OrgList += '</div>';

            if (OrgList == "") {
                OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">Organizational Levels are not configured for this Year of Assessment.</label></div>';

            }
            document.getElementById('OrganizationalLevel').innerHTML = OrgList;

            for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                for (var l = 0; l < VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                    ko.applyBindingsToNode($('#sublevel' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: VRViewModel.SubCheckboxSelected } }, VRViewModel);
                }
            }

            for (var k = 0; k < VRViewModel.BusinessUnitListForFilters().length; k++) {
                ko.applyBindingsToNode($('#sublevelBU' + VRViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: VRViewModel.SubCheckboxSelected } }, VRViewModel);
            }
            $('#ScattorplotSpin').hide();
            VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: BindHTML function in ResidualRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------------------Logic for binding HTML to the front end ends here----------------------------------------------------------------------------------------------------//
    function BusinessLevelsModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
            self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            self.BlId = ko.observable(item.BlId)
            var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                return new BuLevelValueListModel(result);
            });
            self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function SubCheckboxSelected(data, event) {
        try {
            $('#OrgFilterError').hide();
            $('#BUFilterError').hide();
            $('#OrgSingleFilterError').hide();

            var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
            var BUselected = "";
            if (isNaN(parseInt(selectedSubOrgLevelID)) && VRViewModel.SelectedCheckedList().length > 0) {
                $('#BUFilterError').show();
                return false;
            }
            else if (!isNaN(parseInt(selectedSubOrgLevelID)) && VRViewModel.SelectedCheckedBUList().length > 0) {
                $('#OrgFilterError').show();
                return false;
            }
            else if (!isNaN(parseInt(selectedSubOrgLevelID)) && VRViewModel.SelectedCheckedList().length > 0) {
                $('#OrgSingleFilterError').show();
                return false;
            }
            else if (!isNaN(parseInt(selectedSubOrgLevelID)) && VRViewModel.SelectedCheckedBUList().length == 0) {
                for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                    var counterCheck = 0;
                    for (var g = 0; g < VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                        if (VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                            if (event.currentTarget.checked) {
                                $("#sublevel" + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                $('.fa-check.' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                VRViewModel.SelectedCheckedList.push({
                                    SubLevelId: VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                    SubLevelName: VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                    OrgLevelName: VRViewModel.OrgLvlDrpDwnList()[i].BlName()
                                });
                            }
                            else {
                                $("#sublevel" + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                $('.fa-check.' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                if (VRViewModel.SelectedCheckedList().length > 0) {
                                    VRViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                }
                            }
                        }

                        //Mark parent check box as checked if all sub levels are selected
                        if ($("#sublevel" + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                            counterCheck++;
                        }
                        if (counterCheck > 0 && counterCheck == VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                            $("#" + VRViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                        }
                        else if (counterCheck > 0 && counterCheck == VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                            $("#" + VRViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                        }
                    }
                }
                //Logic to re-set the BU list
                VRViewModel.BusinessUnitListForFilters([]);
                if (VRViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(VRViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < VRViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == VRViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    VRViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    VRViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    VRViewModel.BusinessUnitListForFilters([]);
                    mappedBuList = $.map(VRViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    VRViewModel.BusinessUnitListForFilters(mappedBuList);
                    VRViewModel.FinalOrgFilterList(mappedBuList);
                }
                SetFilterSelection();

            } else if (isNaN(parseInt(selectedSubOrgLevelID)) && VRViewModel.SelectedCheckedList().length == 0) {
                return true; //To-do need to work on selected bu filter, currently no code to support this
                BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                for (var i = 0; i < VRViewModel.BusinessUnitListDUP().length; i++) {
                    if (VRViewModel.BusinessUnitListDUP()[i].BusinessUnitId() == BUselected) {
                        if (event.currentTarget.checked) {
                            $("#sublevelBU" + BUselected).prop("checked", true);
                            $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                            VRViewModel.SelectedCheckedBUList.push({
                                SubLevelId: VRViewModel.BusinessUnitListDUP()[i].BusinessUnitId(),
                                SubLevelName: VRViewModel.BusinessUnitListDUP()[i].BusinessUnitName()
                            });
                        }
                        else {
                            $("#sublevelBU" + BUselected).prop("checked", false);
                            $('.fa-check.' + BUselected).css({ 'display': 'none' });
                            if (VRViewModel.SelectedCheckedBUList().length > 0) {
                                VRViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == VRViewModel.BusinessUnitListDUP()[i].BusinessUnitId() })
                            }
                        }
                    }
                }

                if (VRViewModel.SelectedCheckedBUList().length > 0) {
                    //Logic to re-set the BU list
                    VRViewModel.BusinessUnitListForFilters([]);

                    var mappedBuList = $.map(VRViewModel.BusinessUnitListDUP(), function (result) {
                        for (var m = 0; m < VRViewModel.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == VRViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    VRViewModel.BusinessUnitListForFilters(mappedBuList);
                }
                else {
                    VRViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(VRViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    VRViewModel.BusinessUnitListForFilters(mappedBuList);
                    VRViewModel.FinalOrgFilterList(mappedBuList);
                }
                SetBUFilterSelection();
            }
            //Set count of BU's selected
            if (VRViewModel.BusinessUnitListForFilters().length > 0) {
                VRViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return VRViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                VRViewModel.BusinessUnitListForFilters(VRViewModel.DistinctFileredBUs());
            }

            VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length)
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: SubCheckboxSelected function in ResidualRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }

    function SetBUFilterSelection() {
        try {
            document.getElementById('DynamicOrgOptedFilters').innerHTML = "";

            var contentHtml = "";
            for (var k = 0; k < VRViewModel.SelectedCheckedBUList().length; k++) {
                contentHtml += '<div id="DynamicBUOptedFilters_' + VRViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span>BU </span> : ' + VRViewModel.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + VRViewModel.SelectedCheckedBUList()[k].SubLevelId + '" data-bind="click:ClearBUFilterSelection" class="f-clear"><i class="demo-icon icon-cross_special"></i></span></span></div>';
            }

            document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < VRViewModel.SelectedCheckedBUList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterTextBU_' + VRViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: VRViewModel.ClearBUFilterSelection }, VRViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in ResidualRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }

    function BuLevelValueListModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
            self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
            self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
            self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
            self.TargetRow = ko.observable(item.TargetRow);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function SetFilterSelection() {
        try {
            document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
            //Mark Org levels filter seletion
            var contentHtml = "";
            for (var k = 0; k < VRViewModel.SelectedCheckedList().length; k++) {
                contentHtml += '<div id="DynamicOptedFilters_' + VRViewModel.SelectedCheckedList()[k].SubLevelId + '" style="margin-right: 1rem;float: left;"><span style="font-size: 11px;background-color: white;font-weight: 600;border-radius: 10px; border: 1px solid #c5c3c3;"><span style="font-weight: 400; padding-left: 1rem;">' + VRViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + VRViewModel.SelectedCheckedList()[k].SubLevelName + '<button id="ClearFilterText_' + VRViewModel.SelectedCheckedList()[k].SubLevelId + '" class="btn" style="font-weight:bold;background:transparent;margin-bottom:3px;" data-bind="click:ClearOrgFilterSelection">x</button></span></div>';
            }
            document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
            for (var k = 0; k < VRViewModel.SelectedCheckedList().length; k++) {
                ko.applyBindingsToNode($('#ClearFilterText_' + VRViewModel.SelectedCheckedList()[k].SubLevelId), { click: VRViewModel.ClearOrgFilterSelection }, VRViewModel);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function ClearOrgFilterSelection(data, event) {
        try {

            var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);;

            document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

            $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
            if (VRViewModel.SelectedCheckedList().length > 0) {
                VRViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
            }

            //Logic to re-set the BU list
            VRViewModel.BusinessUnitListForFilters([]);
            var mappedBuList = $.map(VRViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                return new BusinessUnitModelDUP(result);
            });
            VRViewModel.BusinessUnitListForFilters(mappedBuList);
            VRViewModel.FinalOrgFilterList(mappedBuList);

            if (VRViewModel.SelectedCheckedList().length < 2) {
                $('#OrgFilterError').hide();
                $('#OrgSingleFilterError').hide();

            }

            //Set count of BU's selected
            if (VRViewModel.BusinessUnitListForFilters().length > 0) {
                VRViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return VRViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                VRViewModel.BusinessUnitListForFilters(VRViewModel.DistinctFileredBUs());
            }

            VRViewModel.NumberOfBUsSelected(VRViewModel.BusinessUnitListForFilters().length)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    //Mocked Model captures different types of filters to apply
    function FilterTypeModel(item) {
        try {
            var self = this;
            self.FilterType = ko.observable(item.FilterType);
            self.FilterTypeId = ko.observable(item.FilterTypeId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FilterTypeModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    //function call to pull the speedometer data starts here
    function showallErrors() {
        $("#chart-div-1").html("");
        $("#chart-div-2").html("");
        $("#chart-div-3").html("");
        $("#inherentspeedometererror").show();
        $("#Controlsspeedometererror").show();
        $("#Residualspeedometererror").show();
    }
    function GetSpeedometerData() {
        try {

            //VRViewModel.SelectedAssessmentType()
            $.ajax({
                url: "/api/Visualization/GetSpeedometerData",
                type: "GET",
                data: { SuborgLevelId: VRViewModel.SelectedCheckedList()[0].SubLevelId, AssessmentId: VRViewModel.SelectedAssessmentType() },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    var SpeedoMeterData = $.map(jsonResult, function (result) {
                        return new SpeedometerModel(result);
                    });
                    showallErrors();
                    for (var i = 0; i < SpeedoMeterData.length; i++) {
                        if (SpeedoMeterData[i].Type() == "INH") {
                            $("#chart-div-1").html("");
                            var datalenstart = [];
                            datalenstart.push(SpeedoMeterData[i].Calculatedscore())
                            datalenstart.push(SpeedoMeterData[i].MaxScore() - SpeedoMeterData[i].Calculatedscore());
                            var tickslegendstart = []

                            tickslegendstart.push(parseInt(SpeedoMeterData[i].Calculatedscore()));
                            var color = [];
                            color.push(SpeedoMeterData[i].HexCode());
                            color.push('white');
                            var percentage = (SpeedoMeterData[i].Calculatedscore() / SpeedoMeterData[i].MaxScore()) * 100;
                            var Names = [SpeedoMeterData[i].Description()];

                            RenderSpeedometer("chart-div-1", datalenstart, Names, percentage, tickslegendstart, 1, SpeedoMeterData[i].MaxScore(), color);
                            $("#chart-div-1label").html("");
                            $("#chart-div-1label").html(
                                //"Inherent Risk"
                                (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentRisk') == -1) ? 'Inherent Risk' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentRisk')].Name()
                                + " : " + SpeedoMeterData[i].Description())
                            $("#inherentspeedometererror").hide();

                        }
                        else if (SpeedoMeterData[i].Type() == "CTRL") {
                            $("#chart-div-2").html("");
                            var datalenstart = [];
                            datalenstart.push(SpeedoMeterData[i].Calculatedscore())
                            datalenstart.push(SpeedoMeterData[i].MaxScore() - SpeedoMeterData[i].Calculatedscore());
                            var tickslegendstart = []

                            tickslegendstart.push(parseInt(SpeedoMeterData[i].Calculatedscore()));
                            var color = [];
                            color.push(SpeedoMeterData[i].HexCode());
                            color.push('white');
                            var percentage = (SpeedoMeterData[i].Calculatedscore() / SpeedoMeterData[i].MaxScore()) * 100;
                            var Names = [SpeedoMeterData[i].Description()];
                            RenderSpeedometer("chart-div-2", datalenstart, Names, percentage, tickslegendstart, 1, SpeedoMeterData[i].MaxScore(), color);
                            $("#chart-div-2label").html("");
                            $("#chart-div-2label").html(
                                //"Controls Rating" +
                                (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsRating') == -1) ? 'Controls Rating' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsRating')].Name()
                                + " : " + SpeedoMeterData[i].Description())
                            $("#Controlsspeedometererror").hide();

                        }
                        else {
                            $("#chart-div-3").html("");
                            var datalenstart = [];
                            datalenstart.push(SpeedoMeterData[i].Calculatedscore())
                            datalenstart.push(SpeedoMeterData[i].MaxScore() - SpeedoMeterData[i].Calculatedscore());
                            var tickslegendstart = []

                            tickslegendstart.push(parseInt(SpeedoMeterData[i].Calculatedscore()));
                            var color = [];
                            color.push(SpeedoMeterData[i].HexCode());
                            color.push('white');
                            var percentage = (SpeedoMeterData[i].Calculatedscore() / SpeedoMeterData[i].MaxScore()) * 100;
                            var Names = [SpeedoMeterData[i].Description()];
                            RenderSpeedometer("chart-div-3", datalenstart, Names, percentage, tickslegendstart, 0, SpeedoMeterData[i].MaxScore(), color);
                            $("#chart-div-3label").html("");
                            $("#chart-div-3label").html(
                                //"Residual Risk"
                                (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResidualRisk') == -1) ? 'Residual Risk' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResidualRisk')].Name()
                                + " : " + SpeedoMeterData[i].Description())
                            $("#Residualspeedometererror").hide();
                        }


                    }
                    $("#SpeedomterLoading").hide();
                    $("#Speedomterdiv").show();
                })
                .fail(function (error, fail) {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail method in GetSpeedometerData.js';
                    logger.logMessage(msg);
                    $("#SpeedomterLoading").hide();
                    $("#Speedomterdiv").show();
                    return;
                });
            VRViewModel.SelectedCheckedList()[0].SubLevelId

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSpeedometerData() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    //function call to pull the speedometer datae nds here
    //clear filter event
    function ClearAllBuFitlers(data, event) {
        try {
            VRViewModel.BusinessUnitList(VRViewModel.BusinessUnitListDUP());
            //CreateCalculationTable();
            //Logic to reset the below page

            $('#ScattorplotSpin').show();
            $('#RiskDashboardSubContainer').css({ "display": "none" });

            if (VRViewModel.OrgLvlDrpDwnList() != undefined) {
                if (VRViewModel.OrgLvlDrpDwnList().length > 0) {
                    if (VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList() != undefined) {
                        if (VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList().length > 0) {

                            VRViewModel.SelectedCheckedList([]);

                            $("#sublevel" + VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueId()).prop("checked", true);
                            $('.fa-check.' + VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueId()).css({ 'display': 'inline-block' });

                            VRViewModel.SelectedCheckedList.push({
                                SubLevelId: VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueId(),
                                SubLevelName: VRViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList()[0].BlvalueName(),
                                OrgLevelName: VRViewModel.OrgLvlDrpDwnList()[0].BlName()
                            });

                            UncheckAllOrgLevels();
                            SetFilterSelection();

                            ApplyBuFitlers();
                        }
                    }
                }
            }

            //VRViewModel.SelectedCheckedList([]);
            //VRViewModel.SelectedCheckedBUList([]);
            closeSideNav();
            //VRViewModel.BUFiltersAppliedRiskDashboard(false);
            //$('.badge').css({ 'display': 'none' });
            //$('#ApplyFilterMessage').css({ 'display': 'block' });
            //document.getElementById('RiskDashboardSubContainer').innerHTML = "";
            //$('#RiskDashboardSubContainer').css({ 'display': 'none' });
            //$('#SelectOrgMessage').css({ 'display': 'none' });
            //$('#f-filter').css('display', 'none');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClearAllBuFitlers() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function UncheckAllOrgLevels() {
        try {
            if (VRViewModel.OrgLvlDrpDwnList() != undefined) {
                for (var i = 0; i < VRViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList() != undefined) {
                        for (var g = 0; g < VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            $("#sublevel" + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                            $('.fa-check.' + VRViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                        }
                    }
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    //this model captures businessunits
    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
            self.BuName = ko.observable($('<div/>').html(item.BuName).text());
            self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            self.SubLevelId = ko.observable(item.SubLevelId);
            self.isChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    //this model captures businessunits to remap
    function BusinessUnitModelDUP(item) {
        try {
            var self = this;
            self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
            self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
            self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
            self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
            self.SubLevelId = ko.observable(item.SubLevelId());
            self.isChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    //-----------------------------------------------------------Heatmap matrix code---------------------------------------------------------------//
    function GetHeatMap(subOrgLevelId, AssessementTypeId) {
        // 1-green, 2-yellow, 3-orange, 4 red
        $('#ScattorplotSpin').show();

        // var data1 = [{ "day": 5, "hour": 1, "value": 1 },
        //              { "day": 5, "hour": 2, "value": 1 },
        //              { "day": 5, "hour": 3, "value": 2 },
        //              { "day": 4, "hour": 1, "value": 1 },
        //              { "day": 4, "hour": 2, "value": 2 },
        //              { "day": 4, "hour": 3, "value": 4 },
        //              { "day": 3, "hour": 1, "value": 2 },
        //              { "day": 3, "hour": 2, "value": 4 },
        //              { "day": 3, "hour": 3, "value": 4 },
        // ];

        // var data = [
        //{ "day": 5, "hour": 1, "value": 1 }, { "day": 5, "hour": 2, "value": 1 }, { "day": 5, "hour": 3, "value": 1 }, { "day": 5, "hour": 4, "value": 2 }, { "day": 5, "hour": 5, "value": 3 },
        //{ "day": 4, "hour": 1, "value": 1 }, { "day": 4, "hour": 2, "value": 2 }, { "day": 4, "hour": 3, "value": 2 }, { "day": 4, "hour": 4, "value": 3 }, { "day": 4, "hour": 5, "value": 4 },
        //{ "day": 3, "hour": 1, "value": 1 }, { "day": 3, "hour": 2, "value": 2 }, { "day": 3, "hour": 3, "value": 3 }, { "day": 3, "hour": 4, "value": 4 }, { "day": 3, "hour": 5, "value": 4 },
        //{ "day": 2, "hour": 1, "value": 2 }, { "day": 2, "hour": 2, "value": 3 }, { "day": 2, "hour": 3, "value": 4 }, { "day": 2, "hour": 4, "value": 4 }, { "day": 2, "hour": 5, "value": 4 },
        //{ "day": 1, "hour": 1, "value": 3 }, { "day": 1, "hour": 2, "value": 4 }, { "day": 1, "hour": 3, "value": 4 }, { "day": 1, "hour": 4, "value": 4 }, { "day": 1, "hour": 5, "value": 4 }
        // ];

        var lengendData = [{ "hour": 1, "contenttext": 'Outside risk tolerance, mitigate risk within 3 months' },
        { "hour": 2, "contenttext": 'Outside risk tolerance, mitigate risk within 1 year' },
        { "hour": 3, "contenttext": 'Within risk tolerance, further action at the direction of local management' },
        { "hour": 4, "contenttext": 'Within risk tolerance, no further action required' }
        ];


        try {
            $.ajax({
                url: "/api/Visualization/GetScatteredPlotDataForSubOrg",
                type: "GET",
                data: { SubOrgLevelId: subOrgLevelId, AssessementTypeId: AssessementTypeId },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetScatteredPlotData() method in RiskDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult != null) {
                    $('#scatterPlotChartError').hide();
                    $('#loadingMainImgDiv').hide();
                    if (jsonResult.HeatmapBUModelList != null) {
                        $('#scatterPlotChartError').hide();
                    } else {
                        $('#scatterPlotChartError').show();
                    }
                    //Map Rect scatterplot data
                    var MappedPlotList = $.map(jsonResult.HeatmapScaleList, function (result) {
                        return new HeatMapRectangleModel(result);
                    });
                    VRViewModel.HeatMapRectangleList(MappedPlotList);

                    //Map BU scatterplot data
                    var MappedBUPlotList = $.map(jsonResult.HeatmapBUModelList, function (result) {
                        return new HeatMapModel(result);
                    });
                    VRViewModel.RiskDashboardHeatMapList(MappedBUPlotList);

                    if (VRViewModel.RiskDashboardHeatMapList().length > 0 && VRViewModel.HeatMapRectangleList().length > 0) {
                        //heatmapChart(data1, VRViewModel.RiskDashboardHeatMapList(), lengendData);
                        $('#scatterPlotChartError').hide();
                        heatmapChart(VRViewModel.HeatMapRectangleList(), VRViewModel.RiskDashboardHeatMapList(), jsonResult.InherentAxisList, jsonResult.ControlAxisList);
                    } else {
                        $('#scatterPlotChartError').show();
                    }
                    //Map BU lengend data
                    var MappedBUModelList = $.map(jsonResult.HeatmapBUModelList, function (result) {
                        return new BusinessUnitLegendModel(result);
                    });

                    //VRViewModel.BusinessUnitListForHeatMap(MappedBUModelList);
                    //Map rectangle blocks lengend data
                    var MappedBlockList = $.map(jsonResult.RectangleLegendList, function (result) {
                        return new HeatmapRectLengedModel(result);
                    })

                    VRViewModel.HeatmapLegendList(MappedBlockList);

                    GetBusinessUnitNameData();

                    MappedBUModelList.sort(SortByName);
                    VRViewModel.BusinessUnitListForHeatMap(MappedBUModelList);
                } else {
                    $('#scatterPlotChartError').show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail method in RiskDashboard.js';
            logger.logMessage(msg);
            return;
        };

    }

    function SortByName(a, b) {

        var aName = parseInt(a.BusinessUnitCounter());
        var bName = parseInt(b.BusinessUnitCounter());
        return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
    }

    function BusinessUnitLegendModel(item) {
        try {
            var self = this;
            self.BusinessUnitCounter = ko.observable($('<div/>').html(item.BusinessUnitCounter).text());
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitLegendModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function HeatMapRectangleModel(item) {
        try {
            var self = this;

            //Need to reverse scores as the heatmap is developed in reversed order
            switch (item.InherentRiskScore) {
                case 1:
                    item.InherentRiskScore = 5;
                    break;
                case 2:
                    item.InherentRiskScore = 4;
                    break;
                case 4:
                    item.InherentRiskScore = 2;
                    break;
                case 5:
                    item.InherentRiskScore = 1;
                    break;
            }

            self.hour = item.ControlRiskScore;
            self.day = item.InherentRiskScore;
            self.value = item.ColorCode;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HeatMapModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function HeatMapModel(item) {
        try {
            var self = this;
            self.hour = item.ControlRatingScore;
            self.day = item.InherentRiskScore;
            self.contenttext = item.BusinessUnitName;
            self.content = item.BusinessUnitCounter;
            self.value = item.Value;
            self.counter = item.Counter;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HeatMapModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function HeatmapRectLengedModel(item) {
        try {
            var self = this;
            self.LegendScaleName = item.LegendScaleName;
            self.ColorCode = item.ColorCode;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HeatmapRectLengedModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    ///Summary///
    // heatmapChart : main function to generate heatmap matrix
    // data : static json object to generate rectangles with different positions and colors
    // lengendData : static json object to generate legend panel with colors from below array: "colorv1"
    // dataCircle: database object with valid data for each selected question i.e., option from drop down
    ///Summary///
    function heatmapChart(data, dataCircle, days, times) {
        try {
            var reCreate = d3.select("#scatterPlotChart"); // get this element by id from html for matrix
            reCreate.selectAll("*").remove();
            var reCreateLegend = d3.select("#areaLegend"); // get this element by id from html to create legend of rectangles
            reCreateLegend.selectAll("*").remove();

            var margin = { top: 50, right: 0, bottom: 100, left: 30 },
                buckets = 9;
            // colorv1 = ['red', 'orange', 'yellow', 'yellowgreen', '#a0dcff', 'white'];//color codes for main graph rectangles

            // logic to resize the structure to accommodate more circles inside a single rectangle
            var nested_data = d3.nest()
                .key(function (d) { return d.hour; })
                .key(function (d) { return d.day; })
                .rollup(function (leaves) { return leaves.length; })
                .entries(dataCircle),

                k = 1;

            for (var i = 0; i < nested_data.length; i++) {
                for (var j = 0; j < nested_data[i].values.length; j++) {
                    if (nested_data[i].values[j].values > k) {
                        k = (nested_data[i].values[j].values);
                    }
                }
            }

            var width = 480 - margin.left - margin.right,
                gridSize = Math.floor(width * 2 / 15) + 20,

                xLabelTransition = 450,
                marginbottom_g = 0,
                marginLeft_g = margin.left + 110,
                svgStyle = "margin-left: unset;";
            //days = [];

            var height = 430 - margin.top;



            if (days.length <= 3) {
                // days = ["1 -Low", "2 -Moderate", "3 -High"]; //y-axis panel text
                // times = ["-Effective", "Effective-Moderately", "-Weak"]; //x-axis panel text
                heightToApplyOnSvg = height - days.length * 50 - 63;
                marginbottom_g = margin.bottom - 260;
            }

            else if (days.length > 3) {
                heightToApplyOnSvg = height - days.length * 50;
                marginbottom_g = margin.bottom - 100 - days.length * 50;
            }
            if (times.length > 4) {
                width = width + 120;
            }
            days = days.reverse();
            //build main svg form html div "chart"
            var svg = d3.select("#scatterPlotChart").append("svg")
                .attr("width", width + margin.left + margin.right)
                //.attr("height", heightToApplyOnSvg + margin.top + margin.bottom)
                .attr("height", 420)
                .append("g")
                //.attr("transform", "translate(" + marginLeft_g + "," + marginbottom_g + ")");
                .attr("transform", "translate(" + marginLeft_g + ",-60)");


            var yScale = d3.scale.ordinal()
            yAxis = d3.svg.axis()
                .scale(yScale)
                .orient('left');

            var xScale = d3.scale.linear()
            xAxis = d3.svg.axis()
                .scale(xScale)
                .orient('bottom');

            svg.append("text")
                .attr("text-anchor", "end")
                //.attr("x", (gridSize / 2) + 80)
                .attr("x", function (d) {
                    if (days.length == 3) {
                        return (gridSize / 2) + 80;
                    } else if (days.length >= 4) {
                        return (gridSize / 2) + 120;
                    }
                })
                .attr("y", (height + margin.top + margin.bottom + 20) - 80)
                .text(
                    //"Control Rating"
                    (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlRating') == -1) ? 'Control Rating' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlRating')].Name()
                )
                .style("text-anchor", "middle")
                .style("font-weight", "bold")
                .style("font-size", "20");

            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", (0 - margin.left - margin.bottom + 30))
                //.attr("x", 0 - (height / 2) - 10)
                .attr("x", function (d) {
                    if (days.length == 3) {
                        return 0 - (height / 2) - 90;
                    } else if (days.length >= 4) {
                        return 0 - (height / 2) - 10;
                    }
                })
                .attr("dy", "1rem")
                .text(
                    //"Inherent Risk"
                    (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentRisk') == -1) ? 'Inherent Risk' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentRisk')].Name()
                )
                .style("text-anchor", "middle")
                .style("font-weight", "bold")
                .style("font-size", "20");

            //build x and y-axis text from static "days" & "times" arrey
            var dayLabels = svg.selectAll(".dayLabel")
                .data(days)
                .enter().append("text")
                .text(function (d) { return d; })
                .call(function (t) {
                    t.each(function (d) { // for each one
                        var self = d3.select(this);
                        var s = self.text().split(' ');  // get the text and split it
                        self.text(''); // clear it out
                        self.append("tspan") // insert two tspans
                            .attr("x", 0)
                            .attr("dy", "10px")
                            .text(s[0]);
                        if (s[2] == undefined) {
                            self.append("tspan")
                                .attr("x", -20)
                                .attr("dy", 0)
                                .text(s[1]);
                        } else {
                            self.append("tspan")
                                .attr("x", -20)
                                .attr("dy", -5)
                                .text(s[1]);
                        }
                        self.append("tspan")
                            .attr("x", -20)
                            .attr("dy", "10px")
                            .text(s[2]);
                    })
                })
                .attr("x", 0)
                //.attr("y", function (d, i) { return (i * gridSize) - 20; })
                .attr("y", function (d, i) {
                    if (days.length == 3) {
                        return ((days.length - 1) * gridSize) - 20 + (i * gridSize);
                    }
                    else if (days.length >= 4) {
                        return (i * gridSize) - 20 + 80;
                    }
                })
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style(" font-size", "11px;")
                .attr("transform", "translate(-6," + gridSize / 1.5 + ")")
                .attr("class", function (d, i) { return ((i >= 0 && i <= 4) ? "dayLabel mono axis axis-workweek" : "dayLabel mono axis"); });
            dayLabels.append("title").html(function (d) { return d; });
            dayLabels.style("cursor", "pointer");

            var xaxisSize = "";
            if (gridSize > 90)
                xaxisSize = (-height + 420);
            else
                xaxisSize = (height + 15) + 35;

            var timeLabels = svg.selectAll(".timeLabel")
                .data(times)
                .enter().append("text")
                .text(function (d) { return d; })

                .call(function (t) {
                    t.each(function (d) { // for each one
                        var self = d3.select(this);

                        var s = self.text().split(' ');  // get the text and split it
                        self.text(''); // clear it out

                        if (s[0] != undefined && s[0] != "" && s[0].length > 11) {
                            s[0] = s[0].substr(0, 10) + "...";
                            s[1] = "";
                        }
                        self.append("tspan") // insert two tspans
                            .attr("dx", "1rem")
                            .attr("y", -20)
                            .attr("x", -20)
                            .text(s[0]);

                        if (s[1] != undefined && s[1] != "" && s[1].length > 11) {
                            s[1] = s[1].substr(0, 10) + "...";
                        }
                        self.append("tspan")
                            .attr("dx", "1rem")
                            .attr("y", -8)
                            .attr("x", -20)
                            .text(s[1]);

                    })
                })
                .attr("x", function (d, i) { return i * gridSize; })
                .attr("y", 0)
                .attr("transform", function (d, i) { return "translate(" + ((i * 90) + 15) + ", " + xLabelTransition + ")" })
                .style("font-family", "sans-serif")
                .style(" font-size", "11px;")
                .attr("class", function (d, i) { return ((i >= 7 && i <= 16) ? "timeLabel mono axis axis-worktime" : "timeLabel mono axis"); });

            timeLabels.append("title").html(function (d) { return d; });
            timeLabels.style("cursor", "pointer");
            //till here:  build x and y-axis text from static "days" & "times" arrey...........................//

            // build rectangles for complete #chart with static "data" array of objects
            var cards = svg.selectAll(".hour")
                .data(data, function (d) { return d.day + ':' + d.hour; });

            cards.enter().append("rect")
                .attr("x", function (d) { return (d.hour - 1) * gridSize; })
                .attr("y", function (d) { return (d.day - 1) * gridSize; })
                .attr("rx", 4)
                .attr("ry", 4)
                .attr("class", "hour bordered")
                .attr("width", gridSize)
                .attr("height", gridSize)

                .attr("fill", function (d) {
                    return d.value;
                    //if (d.value == 1) {
                    //    return "#c4d600";
                    //    //return "yellowgreen";
                    //} else if (d.value == 2) {
                    //    return "#ffcd00";
                    //    //return "yellow";
                    //} else if (d.value == 3) {
                    //    return "#ed8b00";
                    //    //return "orange";
                    //} else if (d.value == 4) {
                    //    return "#da291c";
                    //    //return "red";
                    //} else {
                    //    return "none";
                    //}

                });
            //till here: build rectangles for complete #chart with static "data" array of objects.......................//

            //create circles and position them across the rectangles with "dataCircle" array of objects from DB data
            var kfx = 0, ccx = 0, kfy = 0, ccy = 0;
            var circle_array = svg.selectAll("circle")
                .data(dataCircle);

            var circle = circle_array.enter().append("circle")
                .attr("cx", function (d) {
                    if (k <= 16) {
                        if (d.counter <= 3)
                            return ((d.hour - 1) * gridSize) + 10;//here d.hour is d.x
                        if (d.counter > 3 && d.counter <= 7)
                            return ((d.hour - 1) * gridSize) + 10 + 20;
                        if (d.counter > 7 && d.counter <= 11)
                            return ((d.hour - 1) * gridSize) + 10 + 40;
                        if (d.counter > 11 && d.counter <= 15)
                            return ((d.hour - 1) * gridSize) + 10 + 60;
                        if (d.counter > 15)
                            return ((d.hour - 1) * gridSize) + 10 + 80;
                    }
                    if (d.day != d.hour) {
                        if (d.day == 0) {//d.day is d.y
                            kfx = 0
                        }
                        else { kfx = 20 * d.day; }
                    }
                    return ccx + kfx;
                })
                .attr("cy", function (d) {
                    if (k <= 16) {
                        //flip y
                        if (d.day == 1)
                            d.day = 5;
                        else if (d.day == 2)
                            d.day = 4;
                        else if (d.day == 4)
                            d.day = 2;
                        else if (d.day == 5)
                            d.day = 1;

                        return ((d.day - 1) * gridSize) + 10 + (d.value * 40 / 2);
                    }

                    if (d.day != d.hour) {
                        kfy = 20 * d.hour;// check it should be d.day
                    }
                    return ccy = ccy + kfy;
                })
                .attr("r", function (d) {
                    if (k > 16) { return 10 }
                    else { return 9 };
                })
                .style("fill", "#012169")
                .style("stroke", "#fff")
                .style("cursor", " pointer")


            circle.append("title");
            circle.select("title").text(function (d) { return d.contenttext; });

            //append text on hover of circle with BU unit name
            var circleText = circle_array.enter().append("text")
                .data(dataCircle)
                .attr("dx", function (d) {
                    if (k <= 16) {
                        if (d.counter <= 3)
                            return ((d.hour - 1) * gridSize) + 10;
                        if (d.counter > 3 && d.counter <= 7)
                            return ((d.hour - 1) * gridSize) + 10 + 20;
                        if (d.counter > 7 && d.counter <= 11)
                            return ((d.hour - 1) * gridSize) + 10 + 40;
                        if (d.counter > 11 && d.counter <= 15)
                            return ((d.hour - 1) * gridSize) + 10 + 60;
                        if (d.counter > 15)
                            return ((d.hour - 1) * gridSize) + 10 + 80;
                    }
                    return ccx + kfx;
                })
                .attr("dy", function (d) {
                    if (k <= 16) {
                        return ((d.day - 1) * gridSize) + 14 + (d.value * 40 / 2);
                    }
                })
                .style("fill", "white")
                .style("cursor", " pointer")
                .attr("text-anchor", "middle")
                .text(function (d) { return d.content })
            circleText.append("title");
            circleText.select("title").text(function (d) { return d.contenttext; });


            $("#scatterPlotChartPopUp").html('');
            $("#scatterPlotChartPopUp").html($("#scatterPlotChart").html());


            circle.exit().remove();
            cards.exit().remove();
            circleText.exit().remove();
            //till here : create circles and position them across the rectangles with "dataCircle" array of objects from DB data................//

            ////Create lenegd panel with rectangles to get the meaning of heatmap matrix rectangles
            //var legend = svg.selectAll(".legend")
            //             .data(lengendData, function (d) { return d.hour; });

            //legend.enter().append("g")
            //    .attr("class", "legend");

            //legend.append("rect")
            //  .attr("x", (height + margin.bottom))
            //  .attr("y", function (d) { return (gridSize * (d.hour - 1) + (13 * (d.hour - 1))) + 10; })
            //  .attr("width", gridSize / 5)
            //  .attr("height", gridSize + 20)
            //  .style("fill", function (d, i) { return colorv1[i]; });

            //legend.append("text")
            //  .attr("class", "mono")
            //  .text(function (d) { return d.contenttext; })
            //  .attr("x", (height + margin.bottom) + gridSize / 3)
            //  .attr("y", function (d) { return (gridSize * (d.hour - 0.5) + (15 * (d.hour - 1))) + 10; })
            //  .style("font-family", "sans-serif")
            //  .style("font-size", "11px")
            //  .call(function (t) {
            //       t.each(function (d) { // for each one
            //           var self = d3.select(this);
            //           var s = self.text().split(',');  // get the text and split it
            //           self.text(''); // clear it out
            //           self.append("tspan") // insert two tspans
            //             .attr("dx", "1rem")
            //   .attr("x", (height + margin.bottom) + gridSize / 3)
            //               .attr("y", function (d) { return (gridSize * (d.hour - 0.5) + (15 * (d.hour - 1))) + 10; })
            //             .text(s[0]);
            //           self.append("tspan")
            //             .attr("dx", "1rem")
            //   .attr("x", (height + margin.bottom) + gridSize / 3)
            //               .attr("y", function (d) { return (gridSize * (d.hour - 0.5) + (15 * (d.hour - 1))) + 30; })
            //             .text($.trim(s[1]));
            //       })
            //   })
            //legend.exit().remove();

            var clear = cards.enter().append("circle")
                .data(dataCircle)
                .call(function (t) {
                    t.each(function (d) {
                        //re-flip y
                        if (d.day == 5)
                            d.day = 1;
                        else if (d.day == 4)
                            d.day = 2;
                        else if (d.day == 2)
                            d.day = 4;
                        else if (d.day == 1)
                            d.day = 5;
                    })
                });

            if (days.length <= 3 && times.length > 3) {
                $("#scatterPlotChart").css({ 'margin-top': '-10 rem' });
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in heatmap method in RiskDashboard.js';
            logger.logMessage(msg);
        }
        //till here: Create lenegd panel with rectangles to get the meaning of heatmap matrix rectangles...................//
    };

    function openLegendSideNav() {
        try {
            if ($('#ScatterplotLegendBtn').hasClass("openLegend")) {
                closeLegendSideNav();
            } else {
                $('#ScatterplotLegendBtn').addClass("openLegend");
                $('#ScatterplotLegend').show();
                document.getElementById("ScatterplotLegend").style.top = "27rem";
                document.getElementById("ScatterplotLegend").style.height = "46vh";
                document.getElementById("ScatterplotLegend").style.transition = "0";
                document.getElementById("ScatterplotLegend").style.borderBottom = "1px solid #000";
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: openLegendSideNav() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function closeLegendSideNav() {
        try {
            $('#ScatterplotLegendBtn').removeClass("openLegend");
            $('#ScatterplotLegend').hide();
            document.getElementById("ScatterplotLegend").style.height = "0";
            document.getElementById("ScatterplotLegend").style.top = "0";
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeLegendSideNav() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    //Adds the Table HTML
    function GetBusinessUnitNameData() {
        try {
            var HtmlBody = '<table id="tblBusinessUnit" class="dataTable table-bordered no-footer" cellspacing="1">' +
                '<thead>' +
                '<tr>' +
                '<th class="site_name" style="font-size: 17px !important;text-align: center;width: 20%;"> # </th>' +
                '<th class="site_name">' + ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnitName') == -1) ? 'Business Unit Name' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnitName')].Name()) +  ' </th>' +
                '</tr>' +
                '</thead>' +
                '<tbody data-bind="foreach: BusinessUnitListForHeatMap">' +
                '<tr style="text-align: center;">' +
                '<td><span class="numberCircle" data-bind="text: BusinessUnitCounter"></span></td>' +
                '<td style="text-align: left;" data-bind="text: BusinessUnitName"></td>' +
                '</tr>' +
                '</tbody>' +
                '</table>';
            document.getElementById('areaLegend').innerHTML = HtmlBody;
            ko.applyBindingsToNode($('#tblBusinessUnit').find('tbody').get(0), { foreach: VRViewModel.BusinessUnitListForHeatMap }, VRViewModel);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetFactorTabData() method in HeatmapMatrix.js';
            logger.logMessage(msg);
        }
    }
    //----------------------------------------------------------HEATMAP Matrix Till Here-----------------------------------------------------------------------------------------------//


    //--------------------------------------------------------------Distribution BAR chart starts here---------------------------------------------------------------------------------//

    //-----------------------------------------------------------Logic for the Function that generates chart for the first time(i.e. on Load)-----------------------------------------------

    function InherentRiskDistributionChart(subOrgLevelId, AssessementTypeId) {
        try {
            $.ajax({
                url: "/api/Visualization/GetInherentRiskDistribution",
                data: { SubOrgLevelId: subOrgLevelId, AssessementTypeId: AssessementTypeId },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in InherentRiskDistributionChart() method in RiskDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    $('#inherentRiskDistributionChartError').hide();
                    DrawInherentRiskDistributionChart(jsonResult);

                    if (jsonResult[0].InherentDistributionLegendList != null && jsonResult[0].InherentDistributionLegendList.length > 0) {
                        var MappedLegendList = $.map(jsonResult[0].InherentDistributionLegendList, function (result) {
                            return new InherentDistributionLegendModel(result);
                        })
                        VRViewModel.InherentDistributionLegendList(MappedLegendList);
                    }
                }
                else {
                    $('#inherentRiskDistributionChartError').show();
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(AMLRaViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in InherentRiskDistributionChart() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {

                if (error.status == 401) {
                    app.showMessage(
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        //"You have been logged out. Please login again to complete the operation."
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InherentRiskDistributionChart() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in InherentRiskDistributionChart() method in Reports.js';
                logger.logMessage(msg);
            }
        }
    }
    function InherentDistributionLegendModel(item) {
        try {
            var self = this;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskScore = item.RiskScore;
            self.ColorCode = item.ColorCode;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskRatingLegendModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function DrawInherentRiskDistributionChart(datariskData) {

        try {
        //var datariskData = [{ "CalculatedRiskScore": "1", "BusinessUnitName": "Business Unit 1" },
        //    { "CalculatedRiskScore": "2", "BusinessUnitName": "Business Unit 2" },
        //    { "CalculatedRiskScore": "2.5", "BusinessUnitName": "Business Unit 3" },
        //    { "CalculatedRiskScore": "2", "BusinessUnitName": "Business Unit 4" },
        //    { "CalculatedRiskScore": "3.5", "BusinessUnitName": "Business Unit 5" },
        //];


        var margin = { top: 40, right: 40, bottom: 40, left: 80 },
            //width = 600,
            //height = 250 - margin.top - margin.bottom + (datariskData.length * 20);
            width = 430,
            height = 250 - margin.top - margin.bottom + (datariskData.length * 20);

        var x = d3.scale.linear()
            .domain([0, datariskData[0].ScaleRange])
            .range([0, width - margin.left - margin.right - margin.left - margin.right]);

        var y = d3.scale.ordinal()
            .domain(datariskData.map(function (d) {
                if (d.BusinessUnitName.length > 31)
                    return d.BusinessUnitName.substring(0, 31) + '...';
                else
                    return d.BusinessUnitName;
            }))
            // .title(datariskData.map(function (d) { return d.BusinessUnitName; }))
            .rangeBands([0, height - margin.top - margin.bottom]);

        var xAxis = d3.svg.axis()
            .scale(x)
            .orient("bottom")
            .tickFormat(d3.format("d"))
            .tickPadding(3);

        var yAxis = d3.svg.axis()
            .scale(y)
            .orient('left')
            .ticks(1)
            .tickSize(0)
            .tickPadding(6);


        var svg = d3.select('#inherentRiskDistributionChart')
            .append('svg')
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', 'translate(160, 25)');


        var bar = svg.selectAll("g")
            .data(datariskData)
            .enter()
            .append("g");

        svg.append('g')
            .attr('class', 'axis')
            .attr('transform', 'translate(0, ' + (height - margin.top - margin.bottom) + ')')
            .call(xAxis);

        svg.append('g')
            .attr('class', 'axis')
            .call(yAxis);

        var chart = svg.selectAll('.chart')
            .data(datariskData)
            .enter()
            .append('rect')
            .attr('class', 'bar')
            .attr('x', 1)
            .attr('y', function (d, i) {
                if (datariskData.length == 1)
                    return -1 + margin.top + y.rangeBand() * i + 11;
                else if (datariskData.length == 2)
                    return margin.top + y.rangeBand() * i;
                if (datariskData.length > 2 && datariskData.length <= 6)
                    return -1 + margin.top + y.rangeBand() * i - 15;
                else
                    return -1 + margin.top + y.rangeBand() * i - 27;
            })
            .attr('height', 13)
            .style("cursor", "pointer")
            .attr('width', function (d) { return x(d.CalculatedRiskScore) })
            .style("fill", function (d) { return (d.ColorCode) })


        var titleRect = chart.append("title");
        titleRect.html(function (d) {
            return 'Calculated Risk Score : ' + d.CalculatedRiskScore + '\n' + 'Calculated Risk Level : ' + d.CalculatedRiskLevel + '\n' + 'Overridden Risk Level : ' + d.OverriddenRiskLevel + '\n' + 'Final Inherent Risk Rating : ' + d.FinalInherentRiskRating + '\n' + 'Business Unit : ' + d.BusinessUnitName;
        });

        bar.append("text")
            .data(datariskData)
            .attr("x", function (d) { return x(d.CalculatedRiskScore) + 4; })
            .attr('y', function (d, i) {
                if (datariskData.length == 1)
                    return -1 + margin.top + y.rangeBand() * i + 11;
                else if (datariskData.length == 2)
                    return margin.top + y.rangeBand() * i;
                if (datariskData.length > 2 && datariskData.length <= 6)
                    return -1 + margin.top + y.rangeBand() * i - 15;
                else
                    return -1 + margin.top + y.rangeBand() * i - 27;
            })
            .attr("dy", "1em")
            .text(function (d) { return (d.CalculatedRiskScore); })
            .style("color", "#666")
            .style("font-weight", "bold");


        $("#inherentRiskDistributionChartPopUp").html('');
            $("#inherentRiskDistributionChartPopUp").html($("#inherentRiskDistributionChart").html());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskRatingLegendModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function ControlRiskDistributionChart(subOrgLevelId, AssessementTypeId) {
        try {
            $.ajax({
                url: "/api/Visualization/GetControlRatingsDistribution",
                data: { SubOrgLevelId: subOrgLevelId, AssessementTypeId: AssessementTypeId },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in ControlRiskDistributionChart() method in RiskDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    $('#controlRiskDistributionChartError').hide();

                    if (jsonResult[0].ControlDistributionLegendList != null && jsonResult[0].ControlDistributionLegendList.length > 0) {
                        var MappedLegendList = $.map(jsonResult[0].ControlDistributionLegendList, function (result) {
                            return new ControlDistributionLegendModel(result);
                        })
                        VRViewModel.ControlDistributionLegendList(MappedLegendList);
                    }
                    DrawNewControlRiskDistributionChart(jsonResult, VRViewModel.ControlDistributionLegendList());
                    // DrawControlRiskDistributionChart(jsonResult, VRViewModel.ControlDistributionLegendList());
                }
                else {
                    $('#controlRiskDistributionChartError').show();
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(AMLRaViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in ControlRiskDistributionChart() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please login again to complete the operation."
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in ControlRiskDistributionChart() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in ControlRiskDistributionChart() method in Reports.js';
                logger.logMessage(msg);
            }
        }
    }

    function ControlDistributionLegendModel(item) {
        try {
            var self = this;
            self.RiskLevelName = item.RiskLevelName;
            self.Range = item.Range;
            self.ColorCode = item.ColorCode;
            self.UpperBound = item.UpperBound;
            self.IsPercentageFlag = item.IsPercentageFlag;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskRatingLegendModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }


    function DrawControlRiskDistributionChart(datariskData, lineData) {
        var margin = { top: 40, right: 40, bottom: 40, left: 80 },
            // width = 600,
            width = datariskData.length * 10,

            height = 250 - margin.top - margin.bottom + (datariskData.length * 20);

        var x = d3.scale.linear()
            .domain([0, 1])
            .range([0, width - margin.left - margin.right - margin.left - margin.right]);

        var y = d3.scale.ordinal()
            .domain(datariskData.map(function (d) { return d.BusinessUnitName; }))
            .rangeBands([0, height - margin.top - margin.bottom]); /// is this right?


        var xAxis = d3.svg.axis()
            .scale(x)
            .orient("bottom")
            .tickFormat(d3.format(".0%"))
            .ticks(5)
            .tickPadding(3);

        var yAxis = d3.svg.axis()
            .scale(y)
            .orient('left')
            .ticks(1)
            .tickSize(0)
            .tickPadding(6);

        var svg = d3.select('#controlRiskDistributionChart')
            .append('svg')
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', 'translate(150, 25)');

        var barc = svg.selectAll("g")
            .data(datariskData)
            .enter()
            .append("g");

        var lines = svg.append('g')
            .attr('class', 'axis')
            .attr('transform', 'translate(0, ' + (height - margin.top - margin.bottom) + ')')
            .call(xAxis);

        svg.append('g')
            .attr('class', 'axis')
            .call(yAxis);

        var chart = svg.selectAll('.chart')
            .data(datariskData)
            .enter()
            .append('rect')
            .attr('class', 'bar')
            .attr('x', 1)
            //.attr('y', function (d, i) { return margin.top + y.rangeBand() * i - 25; })
            .attr('y', function (d, i) {
                if (datariskData.length == 1)
                    return -1 + margin.top + y.rangeBand() * i + 31;
                else if (datariskData.length == 2)
                    return margin.top + y.rangeBand() * i - 12;
                if (datariskData.length > 2 && datariskData.length <= 6)
                    return -1 + margin.top + y.rangeBand() * i - 5;
                else
                    return -1 + margin.top + y.rangeBand() * i - 25;
            })
            .attr('height', 13)
            .attr('width', function (d) { return (36 * d.CalculatedRiskScore) / 10 })
            .style("fill", function (d) { return (d.ColorCode) });

        for (var i = 0; i < lineData.length; i++) {
            var verticalLines = lines.append('line')
                .attr('x1', lineData[i].UpperBound * 36 / 10)
                .attr('y1', 0)
                .attr('x2', lineData[i].UpperBound * 36 / 10)
                .attr('y2', -height + margin.top + margin.bottom)
                .style("stroke", lineData[i].ColorCode)
                .style("stroke-width", "1.5px")
                .style("cursor", "pointer")
                .style("stroke-dasharray", "4");

            var verLine = svg.selectAll("g")
                .data(lineData[i])
                .enter()
                .append("g");

            verLine.append("title").html(lineData[i].RiskLevelName);

            verLine.append("text")
                .attr("x", lineData[i].UpperBound * 36 / 10)
                .attr('y', -height + margin.top + margin.bottom)
                .attr("dy", "1em")
                .text(lineData[i].RiskLevelName)
                .style("color", "#666")
                .style("font-weight", "bold");
        }

        var titleRect = chart.append("title");
        titleRect.html(function (d) {
            return ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskScore') == -1) ? 'Calculated Risk Score' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskScore')].Name)
                + ' : ' + d.CalculatedRiskScore + '%' + '\n' +
                ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskQASoc') == -1) ? 'Calculated Risk Level' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskQASoc')].Name)
                + ' : ' + d.CalculatedRiskLevel + '\n'
                + ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OverriddenRiskLevel') == -1) ? 'Overridden Risk Level' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OverriddenRiskLevel')].Name)
                + ' : ' + d.OverriddenRiskLevel + '\n'
                + ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalControlRating') == -1) ? 'Final Control Rating' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalControlRating')].Name)
                + ' : ' + d.FinalControlRating;
        });

        barc.append("text")
            .data(datariskData)
            .attr("x", function (d) { return x(d.CalculatedRiskScore / 100) + 4; })
            .attr('y', function (d, i) {
                if (datariskData.length == 1)
                    return -1 + margin.top + y.rangeBand() * i + 31;
                else if (datariskData.length == 2)
                    return margin.top + y.rangeBand() * i - 12;
                if (datariskData.length > 2 && datariskData.length <= 6)
                    return -1 + margin.top + y.rangeBand() * i - 5;
                else
                    return -1 + margin.top + y.rangeBand() * i - 25;
            })
            .attr("dy", "1em")
            .text(function (d) { return (d.CalculatedRiskScore + '%'); })
            .style("color", "#666")
            .style("font-weight", "bold");
    }

    function DrawNewControlRiskDistributionChart(datariskData, lineData) {

        VRViewModel.PercentageFlag(lineData[0].IsPercentageFlag);
        var margin = { top: 20, right: 20, bottom: 70, left: 40 },
            //width = 600 - margin.left - margin.right,

            height = 300 - margin.top - margin.bottom;
        if (datariskData.length > 4) {
            width = datariskData.length * 60 - margin.left - margin.right;
        } else { width = 4 * 60 - margin.left - margin.right; }

        //var x = d3.scale.ordinal().rangeRoundBands([0, width], .05);
        var x = d3.scale.ordinal().rangeRoundBands([0, datariskData.length * 50], .05);

        var y = d3.scale.linear().range([height, 0]);

        var xAxis = d3.svg.axis()
            .scale(x)
            .orient("bottom");
        //.tickFormat(d3.time.format("%Y-%m"));
        var yAxis = "";
        if (VRViewModel.PercentageFlag()) {
            yAxis = d3.svg.axis()
                .scale(y)
                .orient("left")
                .tickFormat(d3.format(".0%"))
                .ticks(5);
        } else {
            yAxis = d3.svg.axis()
                .scale(y)
                .orient("left")
                //.tickFormat(d3.format("0"))
                .ticks(3);
        }
        var svg = d3.select('#controlRiskDistributionChart').append("svg")
            .attr("width", width + margin.left + margin.right)
            //  .attr("height", height + margin.top + margin.bottom)
            .attr("height", 350)

            .append("g")

            .attr("transform", "translate(50 ," + margin.top + ")");

        //x.domain(datariskData.map(function (d) {
        //    if (d.BusinessUnitName.length > 31)
        //        return d.BusinessUnitName.substring(0, 31) + '...';
        //    else
        //        return d.BusinessUnitName; }));
        if (VRViewModel.PercentageFlag())
            y.domain([0, 1]);
        else {
            y.domain([0, lineData[lineData.length - 1].UpperBound]);
        }

        x.domain(datariskData.map(function (d) {
            return d.BusinessUnitName;
        }));


        svg.append("g")
            .attr('class', 'axis')
            .attr("transform", "translate(0," + height + ")")
            .call(xAxis)
            .selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".1em")
            .attr("transform", "rotate(-27)");

        var lines = svg.append("g")
            .attr("class", "y axis")
            .call(yAxis)

        var barc = svg.append("g")
            .data(datariskData);

        svg.selectAll("bar")
            .data(datariskData)
            .enter().append("rect")
            .style("fill", function (d) { return (d.ColorCode) })
            .attr("x", function (d) { return x(d.BusinessUnitName) + 16; })
            //.attr("x", function (d) { d.BusinessUnitName.substring(0, 31) + '...' + 16; })
            .attr("width", 13)
            .attr("y", function (d) {
                if (VRViewModel.PercentageFlag())
                    return y(d.CalculatedRiskScore / 100);
                else
                    return y(d.CalculatedRiskScore);
            })
            .style("cursor", "pointer")
            .attr("height", function (d) {
                if (VRViewModel.PercentageFlag())
                    return height - y(d.CalculatedRiskScore / 100);
                else
                    return height - y(d.CalculatedRiskScore);
            })
            .append("title").html(function (d) {
                if (VRViewModel.PercentageFlag())
                    return ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskScore') == -1) ? 'Calculated Risk Score' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskScore')].Name())
                            //'Calculated Risk Score'
                        + ' : ' + d.CalculatedRiskScore + '%' + '\n' +
                        //'Calculated Risk Level'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskQASoc') == -1) ? 'Calculated Risk Level' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskQASoc')].Name())
                        + ' : ' + d.CalculatedRiskLevel + '\n' +
                        //'Overridden Risk Level'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OverriddenRiskLevel') == -1) ? 'Overridden Risk Level' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OverriddenRiskLevel')].Name())
                        + ' : ' + d.OverriddenRiskLevel + '\n' +
                        //'Final Control Rating'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalControlRating') == -1) ? 'Final Control Rating' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalControlRating')].Name())
                        + ' : ' + d.FinalControlRating + '\n' +
                        //'Business Unit'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnitName') == -1) ? 'Business Unit' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnitName')].Name())
                        + ' : ' + d.BusinessUnitName;
                else
                    return
                    //'Calculated Risk Score'
                    ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskScore') == -1) ? 'Calculated Risk Score' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskScore')].Name())
                        + ' : ' + d.CalculatedRiskScore + '\n' +
                        //'Calculated Risk Level'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskQASoc') == -1) ? 'Calculated Risk Level' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculatedRiskQASoc')].Name())
                        + ' : ' + d.CalculatedRiskLevel + '\n' +
                        //'Overridden Risk Level'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OverriddenRiskLevel') == -1) ? 'Overridden Risk Level' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OverriddenRiskLevel')].Name())
                        + ' : ' + d.OverriddenRiskLevel + '\n' +
                        //'Final Control Rating'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalControlRating') == -1) ? 'Final Control Rating' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalControlRating')].Name())
                        + ' : ' + d.FinalControlRating + '\n' +
                        //'Business Unit'
                        ((!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnitName') == -1) ? 'Business Unit' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnitName')].Name())
                        + ' : ' + d.BusinessUnitName;

            });

        for (var k = 0; k < datariskData.length; k++) {
            barc.append("g").append("text")
                //.data(datariskData)
                .attr("x", x(datariskData[k].BusinessUnitName) + 14)
                .attr("x", function (d) {
                    if (VRViewModel.PercentageFlag())
                        return x(datariskData[k].BusinessUnitName) + 14;
                    else
                        return x(datariskData[k].BusinessUnitName) + 20;
                })
                //.attr('y', y(datariskData[k].CalculatedRiskScore / 100) - 15)
                .attr('y', function (d) {
                    if (VRViewModel.PercentageFlag())
                        return y(datariskData[k].CalculatedRiskScore / 100) - 15;
                    else
                        return y(datariskData[k].CalculatedRiskScore) - 15;
                })
                .attr("dy", "1em")
                .text(function (d) {
                    if (VRViewModel.PercentageFlag())
                        return (datariskData[k].CalculatedRiskScore + '%');
                    else
                        return (datariskData[k].CalculatedRiskScore);
                })
                .style("color", "#666")
                .style("font-weight", "bold");
        }


        for (var i = 0; i < lineData.length; i++) {
            var verticalLines = lines.append('line')
                .attr('x1', 0)
                //.attr('y1', 210 - (lineData[i].UpperBound / 100 * 210))//210 is the actual height
                .attr('y1', function (d) {
                    if (VRViewModel.PercentageFlag())
                        return 210 - (lineData[i].UpperBound / 100 * 210);
                    else
                        return 210 - (lineData[i].UpperBound / 2 * 210);
                })
                .attr('x2', 50 * datariskData.length)
                //.attr('y2', 210 - (lineData[i].UpperBound / 100 * 210))
                .attr('y2', function (d) {
                    if (VRViewModel.PercentageFlag())
                        return 210 - (lineData[i].UpperBound / 100 * 210);
                    else
                        return 210 - (lineData[i].UpperBound / 2 * 210);
                })
                .style("stroke", lineData[i].ColorCode)
                .style("stroke-width", "2px")
                .style("cursor", "pointer")
                .style("stroke-dasharray", "4")
                .append("title").html(lineData[i].UpperBound + ' - ' + lineData[i].RiskLevelName);

        }

        $("#controlRiskDistributionChartPopUp").html('');
        $("#controlRiskDistributionChartPopUp").html($("#controlRiskDistributionChart").html());
    }
    //----------------------------------------------------------------Distribution BAR chart ends here--------------------------------------------------------------------------------//

    //----------------------------------------------------------------Trend Analysis------------------------------------------------------------------------------//

    function SearchProfiles() {
        try {
            SearchProfilesOnSearch(VRViewModel.SelectedCheckedList()[0].SubLevelId, VRViewModel.SelectedAssessmentType(), VRViewModel.SelectedProfileOne(), VRViewModel.SelectedProfileTwo());
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in GetTrendAnalysisData() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    function SearchProfilesOnSearch(subOrgLevelId, assessementTypeId, profileOne, profileTwo) {
        try {
            $.ajax({
                url: "/api/Visualization/GetTrendAnalysisData",
                type: "GET",
                data: { SubOrgLevelId: subOrgLevelId, AssessementTypeId: assessementTypeId, profileOne: profileOne, profileTwo: profileTwo },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in GetTrendAnalysisData() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    VRViewModel.TrendList([]);
                    var MappedTrendList = $.map(jsonResult, function (result) {
                        return new TrendModel(result);
                    })

                    VRViewModel.TrendList(MappedTrendList);
                    if (VRViewModel.TrendList().length > 0) {
                        $("#trendAnalysisChart").show();
                        VRViewModel.TrendListFlag(true);
                        $("#ResidualMatrixPanel").removeClass('residualMatrixHeight');
                        $("#ResidualMatrixPanel").addClass('residualMatrixHeightWithTA');
                    } else {
                        $("#trendAnalysisChart").hide();
                        VRViewModel.TrendListFlag(false);
                        $("#ResidualMatrixPanel").addClass('residualMatrixHeight');
                    }

                    for (var iData = 0; iData < VRViewModel.ProfileList().length; iData++) {
                        if (VRViewModel.ProfileList()[iData].ProfileId() == VRViewModel.SelectedProfileOne())
                            VRViewModel.ProfileOne(VRViewModel.ProfileList()[iData].ProfileName());

                        if (VRViewModel.ProfileList()[iData].ProfileId() == VRViewModel.SelectedProfileTwo())
                            VRViewModel.ProfileTwo(VRViewModel.ProfileList()[iData].ProfileName());
                    }
                }
                else
                    logger.logMessage(
                        //'An error occurred. Please contact your Application Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()
                        , 'Error', system.getModuleId(VRViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetTrendAnalysisData() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please login again to complete the operation."
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name
                        , (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name(), ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTrendAnalysisData() method in RiskDashboard.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTrendAnalysisData() method in RiskDashboard.js';
                logger.logMessage(msg);
            }
        }
    }

    //Function to bind the applicability Dropdown Dynamically starts here
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    VRViewModel.AssessmentTypeList([]);
                    if (jsonResult != null) {


                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            return new AssessmentListModel(result);
                        });
                        VRViewModel.AssessmentTypeList(MappedAssessmentList);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logMessage(
                        //'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                        (!VRViewModel.LocaleCheckFlag() || VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : VRViewModel.ObjGeneralSettings.LocalizedTextList()[VRViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()
                        , 'Error', system.getModuleId(VRViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }
    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }
    //Function to bind the applicability Dropdown ends here

    function TrendModel(item) {
        var self = this;
        self.TrendId = ko.observable(item.TrendId);
        self.ScaleName = ko.observable(item.ScaleName);
        self.ProfileOne = ko.observable($('<div/>').html(item.ProfileOne).text())
        self.ProfileTwo = ko.observable($('<div/>').html(item.ProfileTwo).text())
        self.Trend = ko.observable($('<div/>').html(item.Trend).text())
        self.ColorCodeP1 = ko.observable($('<div/>').html(item.ColorCodeP1).text())
        self.ColorCodeP2 = ko.observable($('<div/>').html(item.ColorCodeP2).text())
    }
    function SpeedometerModel(item) {
        try {
            var self = this;
            self.MaxScore = ko.observable(item.MaxScore);
            self.MinScore = ko.observable(item.MinScore);
            self.Calculatedscore = ko.observable(item.Calculatedscore);
            self.HexCode = ko.observable(item.HexCode);
            self.Description = ko.observable(item.Description);
            self.Type = ko.observable(item.Type);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SpeedometerModel() method in RiskDashboard.js';
            logger.logMessage(msg);
        }
    }

    //----------------------------------------------------------------Trend Analysis till here------------------------------------------------------------------------------//
});
